module.exports = __webpack_public_path__ + "img/left_hover.23cbb20c.png";